export default {
  // global state
  locale: ''
}